import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Error.css";

export default class Error extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="homebody">
          <div className="container-lg">
            <div className="row">
              <section className="page_404">
                <div className="container-lg">
                  <div className="row">
                    <div className="col-12  text-center">
                      <div className="four_zero_four_bg">
                        <h1 className="text-center ">Not Found</h1>
                      </div>
                      <div className="contant_box_404">
                        <h3 className="h2">Look like you're lost</h3>
                        <p>the page you are looking for not available!</p>
                        <Link to="/" className="link_404">
                          Go to Home
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
